module.exports = __webpack_public_path__ + "img/icon.40ea1fa0.png";